module.exports = __webpack_public_path__ + "img/0.d287a2be.jpg";